import { Component, inject, ChangeDetectionStrategy, input, output } from '@angular/core';
import { ProfileService } from '../../profile.service';
import { ConfirmPopup } from '../../../../confirm.popup';

export interface ITruevo {
  _id: string;
  selected?: boolean;
  details: {
      brand?: string;
      expiryMonth?: string;
      expiryYear?: string;
      holder?: string;
      last4Digits?: string;
  }
}

@Component({
  selector: 'billing-card',
  templateUrl: './billing-card.component.html',
  styleUrls: ['./billing-card.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: []
})
export class BillingCardComponent {
  service = inject(ProfileService);
  confirm = inject(ConfirmPopup);

  card = input.required<ITruevo>();
  select = output<string>();
  remove = output<string>();
  
  constructor() { }

  deleteCard() {
    const cardCount = this.service.membership()?.cards || 0;
    const recurs = this.service.membership()?.recurs || false;
    let msg = 'Are you sure you would like to remove this card?';
    if(this.card().selected && cardCount > 1){
      msg = 'This is the preferred card on your account. By deleting this card, another card will be selected as preferred. Are you sure you want to remove this card?';  
    }

    if(cardCount <= 1 && recurs){
      msg = 'This is the only card linked to your account. By deleting this card you are requesting to stop auto-renewing your subscription. Are you sure you want to remove this card?';
    }
    
    if(msg){
      this.confirm.open('Remove Card', msg, 'Confirm Removal of Card Prompt', [
          {
            label: 'No',
            paint: 'warn',
            close: true
          },
          {
            label: 'Yes',
            paint: 'primary',
            close: true,
            callback: () => this.performDelete()
          }
        ]);
    }
    else
      this.performDelete();
  }

  performDelete(){
    this.service.removeTruevo(this.card()._id).subscribe(deleted => {
      this.service.profile.update(profile => {
        if(profile?.membership){
          profile.membership.cards = Math.max(0,(profile.membership.cards??0)-1);
          profile.membership = Object.assign({}, profile.membership);
        }
        return Object.assign({}, profile);
      });
      this.remove.emit(deleted.message);
    });
  }

}
